import {gsap} from "gsap";
import AnimationChars from "../../../animation/chars/chars";
import AnimationFade from "../../../animation/fade/fade";
import services from "../../../../libs/services";
import EmitEvent, {HT_RESIZE, OBSERVER_HEIGHT_CHANGED, PAGE_LOADED} from "../../../../libs/emit-event";

export class FeatureTeamItemMobile {
    constructor({el, addGroup}) {

        this.DOM = {el};
        this.zIndex = 0;
        this.prop = {};
        this.addGroup = addGroup;
        this.DOM.image = this.DOM.el.querySelector('.js-featureTeamsItem_mobile__mask');

        this.pageLoaded = this.pageLoaded.bind(this);
        this.pageResize = this.pageResize.bind(this);

        this.init();
        this.bindEvent();
    }

    init() {
        this.aniamtions = {
            name: new AnimationChars(this.DOM.el.querySelector('.js-featureTeamsItem_name'), {
                type: "2d",
                _to: {
                    duration: .6
                }
            }),
            position: new AnimationFade(this.DOM.el.querySelector('.js-featureTeamsItem_position'))
        };

        gsap.set(this.DOM.image, {y: '100%'});
        this.DOM.el.style.pointerEvents = 'none';
    }

    animationIn(up = true) {
        this.DOM.el.style.pointerEvents = 'auto';
        this.DOM.el.style.zIndex = '2';
        if (up) {
            this.aniamtions.name.options._from.y = `120%`;
        } else {
            this.aniamtions.name.options._from.y = `-120%`;
        }
        this.aniamtions.name.animationIn();
        this.aniamtions.position.animationIn();
        gsap.killTweensOf(this.DOM.image);
        gsap.fromTo(this.DOM.image, {opacity: 1}, {y: '0%', ease: 'power3.inOut', duration: .6});
    }

    textAnimationOut() {
        this.aniamtions.position.animationOut();
        this.DOM.el.style.pointerEvents = 'none';
        this.DOM.el.style.zIndex = '1';
    }

    animationTop() {
        gsap.killTweensOf(this.DOM.image);
        gsap.to(this.DOM.image, {y: '-100%', delay: .1, opacity: 0, ease: 'power3.inOut', duration: .6});
        this.aniamtions.name.animationOutTop();
        this.textAnimationOut();
    }

    animationBottom() {
        gsap.killTweensOf(this.DOM.image);
        gsap.to(this.DOM.image, {y: '100%', delay: .1, opacity: 0, ease: 'power3.inOut', duration: .6});
        this.aniamtions.name.animationOutBottom();
        this.textAnimationOut();
    }

    getProp() {
        const scrollTop = Math.abs(services.smooth_scrolling_instance);
        const {top, width, height, left} = this.DOM.image.getBoundingClientRect();
        this.prop.top = top + scrollTop;
        this.prop.live = top;
        this.prop.left = left;
        this.prop.width = width;
        this.prop.height = height;
    }

    pageLoaded() {
        this.getProp();
    }

    pageResize() {
        this.getProp();
    }

    bindEvent() {
        EmitEvent.on(OBSERVER_HEIGHT_CHANGED, this.pageResize);
        EmitEvent.on(HT_RESIZE, this.pageResize);
        EmitEvent.on(PAGE_LOADED, this.pageLoaded);
    }

    removeEvent() {
        EmitEvent.off(HT_RESIZE, this.pageResize);
        EmitEvent.off(OBSERVER_HEIGHT_CHANGED, this.pageResize);
        EmitEvent.off(PAGE_LOADED, this.pageLoaded);
    }
}